import { useState } from "react";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import { useMutation } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";

import { formRender, initialValues, custWhSettingValidation } from "./cust-wh-setting-schema";
import { createCustWhSetting, editCustWhSetting } from "services/data.internal.service";
import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomerWarehouseSetting2 from "./components/CustWhSetting2";
import { BackButton } from "ui-components/Button";
import { Success, Error_, LoadingDialog } from "ui-components/Alert";
import { palletTypeObj } from "layouts/views/common/enum";
import { useCustWhSettingQuery } from "hooks/useQueryHook";
function AddCustomerWarehouseSetting2() {
  const location = useLocation();

  const { customerCode } = location?.state ?? {};
  const [formValues, setFormValues] = useState({ ...initialValues, customerCode, upmBase: 1 });
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const [mode, setMode] = useState("ADD");

  const onSuccess = (data) => setAlert(<Success data={data} onChange={setAlert} />);

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(custWhSettingValidation),
  });

  const {
    control,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = form;

  const [
    defRecvWh,
    defRecvZone,
    defRecvLocation,
    defPutawayWh,
    defPutawayZone,
    defPutawayLocation,
    defTRPutawayWh,
    defTRPutawayZone,
    defTRPutawayLocation,
    defShipWh,
    defShipZone,
    defShipLocation,
  ] = watch([
    "defRecvWh",
    "defRecvZone",
    "defRecvLocation",
    "defPutawayWh",
    "defPutawayZone",
    "defPutawayLocation",
    "defTRPutawayWh",
    "defTRPutawayZone",
    "defTRPutawayLocation",
    "defShipWh",
    "defShipZone",
    "defShipLocation",
  ]);

  const { isFetching } = useCustWhSettingQuery({
    customerCode,
    onSuccess: (data) => {
      if (data.data.data !== undefined) {
        const { palletType, ...values } = data.data.data;
        setFormValues({ ...values, palletType: palletType ? palletTypeObj[palletType] : null });
        setMode("EDIT");
      }
    },
    onError,
  });

  const createCustWhSettingMutation = useMutation(createCustWhSetting, {
    onSuccess,
    onError,
  });

  const editCustWhSettingMutation = useMutation(editCustWhSetting, {
    onSuccess,
    onError,
  });

  const infoProps = {
    values: {
      customerCode,
      defRecvWh,
      defRecvZone,
      defRecvLocation,
      defPutawayWh,
      defPutawayZone,
      defPutawayLocation,
      defTRPutawayWh,
      defTRPutawayZone,
      defTRPutawayLocation,
      defShipWh,
      defShipZone,
      defShipLocation,
    },

    formRender,
    control,
    errors,
    setValue,
    mode,
  };

  const onSubmit_old = (data) => {
    if (mode === "ADD") {
      createCustWhSettingMutation.mutate({ ...data, palletType: data.palletType?.value });
    } else {
      editCustWhSettingMutation.mutate({ ...data, palletType: data.palletType?.value });
    }
  };

  const onSubmit = (data) => {
    const payload = { ...data, palletType: data.palletType?.value };
    const mutation = mode === "ADD" ? createCustWhSettingMutation : editCustWhSettingMutation;
    mutation.mutate(payload, {
      onSuccess: (res) => {
        onSuccess(res);
        navigate("/setup/customer/api-setting/add", { state: { customerCode: data.customerCode, apiSecretKey: location.state?.apiSecretKey } });
      },
      onError,
    });
  };

  return (
    <Layout lg={12}>
      {isFetching && <LoadingDialog />}
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CustomerWarehouseSetting2 {...infoProps} />
        <MDBox mt={2} width="100%" display="flex" justifyContent="center">
          <MDButton disabled={false} type="submit" variant="gradient" color="info">
            Save
          </MDButton>
          <BackButton url="/setup/customer" />
        </MDBox>
      </form>
    </Layout>
  );
}

export default AddCustomerWarehouseSetting2;
